import React, {useState, useEffect} from 'react';
import {Link, useLocation, useHistory} from "react-router-dom";
import HeaderLogo from '../../components/HeaderLogo'
import Button from '../../components/Button';

import CloseIcon from '@material-ui/icons/Close';
import Modal from '@material-ui/core/Modal';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';

const areaType = {
    ceiling: 'ผนัง',
    floor: 'พื้น'
}
const roomType = {
    bedroom: 'ห้องนอน',
    restroom: 'ห้องน้ำ',
    kitchen: 'ห้องครัว',
    livingroom: 'ห้องนั่งเล่น',
    multipurposeroom: 'ห้องเอกประสงค์',
    other: 'ห้องอื่นๆ'
}
const floorType = {
    flr1: 'ชั้น 1',
    upperflr_lift: 'อยู่ชั้นบน และมีลิฟต์ขนของ',
    upperflr_nolift: 'อยู่ชั้นบน และไม่มีลิฟต์ขนของ'
}
const localeoptions = { 
    minimumFractionDigits: 2,
    maximumFractionDigits: 2 
};

const servicelink = {
    withTiles: {
      id: 68,
      floor:{
        id: 218,
        //ติดตั้งต่ำกว่า 10
        installStart: {
            id: 930
        },
        installStartLeak: {
            id: 933
        },
        installStartLevel: {
            id: 958
        },
        installStartLeakandLevel: {
            id: 932
        },
        //ติดตั้งต่ำมากกว่า 10
        installUnit: {
            id: 995
        },
        installUnitLeak: {
            id: 994
        },
        installUnitLevel: {
            id: 993
        },
        installUnitLeakandLevel: {
            id: 984
        },
        //รื้อ ติดตั้งต่ำกว่า 10
        removeInstallStart: {
            id: 992
        },
        removeInstallStartLeak: {
            id: 991
        },
        removeInstallStartLevel: {
            id: 990
        },
        removeInstallStartLeakandLevel: {
            id: 989
        },
        //รื้อ ติดตั้งมากกว่า 10
        removeInstallUnit: {
            id: 988
        },
        removeInstallUnitLeak: {
            id: 987
        },
        removeInstallUnitLevel: {
            id: 986
        },
        removeInstallUnitLeakandLevel: {
            id: 985
        },
        // Option เก่า
        preventLeak: {
            id: 932
        },
        leveling: {
            id: 958
        }
      },
      ceiling: {
        id: 219,
        //ติดตั้งต่ำกว่า 10
        installStart: {
            id: 938
        },
        //ติดตั้งต่ำมากกว่า 10
        installUnit: {
            id: 936
        },
        //รื้อ ติดตั้งต่ำกว่า 10
        removeInstallStart: {
            id: 996
        },
        //รื้อ ติดตั้งมากกว่า 10
        removeInstallUnit: {
            id: 997
        }
      }
    },
    noTiles: {
      id: 70,
      floor:{
        id: 221,
        //ติดตั้งต่ำกว่า 10
        installStart: {
            id: 1006 //
        },
        installStartLeak: {
            id: 1007
        },
        installStartLevel: {
            id: 1008
        },
        installStartLeakandLevel: {
            id: 1009
        },
        //ติดตั้งต่ำมากกว่า 10
        installUnit: {
            id: 1005 //
        },
        installUnitLeak: {
            id: 1004 //
        },
        installUnitLevel: {
            id: 1003 //
        },
        installUnitLeakandLevel: {
            id: 951 //
        },
        //รื้อ ติดตั้งต่ำกว่า 10
        removeInstallStart: {
            id: 1002
        },
        removeInstallStartLeak: {
            id: 1001 //
        },
        removeInstallStartLevel: {
            id: 1000 //
        },
        removeInstallStartLeakandLevel: {
            id: 999 //
        },
        //รื้อ ติดตั้งมากกว่า 10
        removeInstallUnit: {
            id: 998 //
        },
        removeInstallUnitLeak: {
            id: 950 //
        },
        removeInstallUnitLevel: {
            id: 960 //
        },
        removeInstallUnitLeakandLevel: {
            id: 948 //
        },
        //Options old
        preventLeak: {
            id: 950
        },
        leveling: {
            id: 960
        }
      },
      ceiling: {
        id: 222,
        //ติดตั้งต่ำกว่า 10
        installStart: {
            id: 956
        },
        //ติดตั้งต่ำมากกว่า 10
        installUnit: {
            id: 1011
        },
        //รื้อ ติดตั้งต่ำกว่า 10
        removeInstallStart: {
            id: 954
        },
        //รื้อ ติดตั้งมากกว่า 10
        removeInstallUnit: {
            id: 1010
        }
      }
    }
}

function CustomServicePage({details, serviceDetail, selectedTile, selectedYaneaw}) {
    const [open, setOpen] = useState(false);
    const [summaryPrice, setSummaryPrice] = useState({
        total: 0,
        discount: 0,
        vat: 0,
        totalvat: 0
    })
    const [serviceText, setServiceText] = useState('')
    const [bookingLink, setBookingLink] = useState('https://24fix.co/booking/step-1')
    const location = useLocation();
    const history = useHistory();
    
    useEffect(()=>{
        let total = 0
        let totaldiscount = 0
        let vat = 0
        let totalvat = 0
        let discount = 1000
        let text = ""
        if(serviceDetail.length > 0){
            serviceDetail.map((detail, index)=>{
                if(detail.selected) {
                    total += detail.price
                    if(index===2) text += ' รวมบริการทากันซึม'
                    else if(index===3) text += ' รวมบริการปรับระดับพื้นที่'
                    else text += detail.name
                }
            })
            setServiceText(text)
            totaldiscount = total-discount
            vat = totaldiscount*0.07
            totalvat = totaldiscount+vat
            setSummaryPrice({
                total,
                discount,
                vat,
                totalvat
            })
        }
        else {
            history.push("/");
            return
        }
        let link = generateLink(bookingLink)
        setBookingLink(link)
    },[])

    function generateLink(link){
        const calArea = Math.ceil(details?.areaSize * (1 + details?.sparePercent/100))
        let note = "&note="
        let vnum = 0
        let level1, level2, level3

        //Level 1 Category
        if(details?.notile){
            note += 'เลือกกระเบื้อง+หาช่าง'
            note += '-กระเบื้อง_'+selectedTile.name
            note += '-ยาแนว_'+selectedYaneaw.name
            link += '?c=' + servicelink.noTiles.id
            level1 = 'noTiles'
        }
        else{
            note += 'หาช่าง'
            link += '?c=' + servicelink.withTiles.id
            level1 = 'withTiles'
        }

        //Level 2 Area Type
        if(details?.areaType==='floor'){
            note += '-กระเบื้องพื้น'
            link += '&s=' + servicelink[level1].floor.id
            level2 = 'floor'
        }
        else if(details?.areaType==='ceiling'){
            note += '-กระเบื้องผนัง'
            link += '&s=' + servicelink[level1].ceiling.id
            level2 = 'ceiling'
        }
        //Level 3 Variant
        let serviceIndexString = ""
        let serviceId, serviceQty

        serviceDetail.map((val, index)=> {
            if(val.selected){
                serviceIndexString += index
            }
        })
        if(calArea < 10) {
            serviceQty = 1
            if(serviceIndexString==="0"){
                serviceId = servicelink[level1][level2]['installStart']['id']
            }
            else if(serviceIndexString==="02"){
                serviceId = servicelink[level1][level2]['installStartLeak']['id']
            }
            else if(serviceIndexString==="03"){
                serviceId = servicelink[level1][level2]['installStartLevel']['id']
            }
            else if(serviceIndexString==="023"){
                serviceId = servicelink[level1][level2]['installStartLeakandLevel']['id']
            }
            else if(serviceIndexString==="1"){
                serviceId = servicelink[level1][level2]['removeInstallStart']['id']
            }
            else if(serviceIndexString==="12"){
                serviceId = servicelink[level1][level2]['removeInstallStartLeak']['id']
            }
            else if(serviceIndexString==="13"){
                serviceId = servicelink[level1][level2]['removeInstallStartLevel']['id']
            }
            else if(serviceIndexString==="123"){
                serviceId = servicelink[level1][level2]['removeInstallStartLeakandLevel']['id']
            }
        }
        else if(calArea > 10) {
            serviceQty = calArea
            if(serviceIndexString==="0"){
                serviceId = servicelink[level1][level2]['installUnit']['id']
            }
            else if(serviceIndexString==="02"){
                serviceId = servicelink[level1][level2]['installUnitLeak']['id']
            }
            else if(serviceIndexString==="03"){
                serviceId = servicelink[level1][level2]['installUnitLevel']['id']
            }
            else if(serviceIndexString==="023"){
                serviceId = servicelink[level1][level2]['installUnitLeakandLevel']['id']
            }
            else if(serviceIndexString==="1"){
                serviceId = servicelink[level1][level2]['removeInstallUnit']['id']
            }
            else if(serviceIndexString==="12"){
                serviceId = servicelink[level1][level2]['removeInstallUnitLeak']['id']
            }
            else if(serviceIndexString==="13"){
                serviceId = servicelink[level1][level2]['removeInstallUnitLevel']['id']
            }
            else if(serviceIndexString==="123"){
                serviceId = servicelink[level1][level2]['removeInstallUnitLeakandLevel']['id']
            }
        }
        link += `&v0id=${serviceId}&v0qty=${serviceQty}`
        vnum++
        // serviceDetail.map((val, index)=> {
        //     if(val.selected){
        //         note += '-' + val.name
        //         if(index===0){
        //             let startid = servicelink[level1][level2]['installStart']['id']
        //             let unitId = servicelink[level1][level2]['installUnit']['id']
        //             let tileArea = calArea
        //             if(tileArea < 10) tileArea = 1
        //             link += `&v${vnum}id=${startid}&v${vnum}qty=${tileArea}`
        //             vnum++
        //             // if(calArea>10) {
        //             //     let remainqty = calArea - 10
        //             //     link += `&v${vnum}id=${unitId}&v${vnum}qty=${remainqty}`
        //             //     vnum++
        //             // }
        //         }
        //         if(index===1){
        //             let startid = servicelink[level1][level2]['removeInstallStart']['id']
        //             let unitId = servicelink[level1][level2]['removeInstallUnit']['id']
        //             let tileArea = calArea
        //             if(tileArea < 10) tileArea = 1
        //             link += `&v${vnum}id=${startid}&v${vnum}qty=${tileArea}`
        //             vnum++
        //             // if(calArea>10) {
        //             //     let remainqty = calArea - 10
        //             //     link += `&v${vnum}id=${unitId}&v${vnum}qty=${remainqty}`
        //             //     vnum++
        //             // }
        //         }
        //         if(index===2){
        //             let startid = servicelink[level1][level2]['preventLeak']['id']
        //             link += `&v${vnum}id=${startid}&v${vnum}qty=${calArea}`
        //             vnum++
        //         }
        //         if(index===3){
        //             let startid = servicelink[level1][level2]['leveling']['id']
        //             link += `&v${vnum}id=${startid}&v${vnum}qty=${calArea}`
        //             vnum++
        //         }
        //     }
        // })
        note += '-พื้นที่ขนาด'+calArea+'ตรม'
        note += '-'+details?.floor
        note += '-ห้อง'+details?.room
        link += '&vnum='+vnum
        link += note
        return link
    }

    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const footerHeight = {height: document.getElementById('fix-footer')?.clientHeight}
    return (
        <div className="page-container">
            <Modal
            open={open}
            onClose={handleClose}
            >
            <div className='contact-modal'>
                <h2 id="simple-modal-title">ขอคำปรึกษาเพิ่มเติม</h2>
                <div>
                    <h3 id="simple-modal-title">
                        <span className="round-icon-wrapper"><PhoneIphoneIcon style={{color: '#FFF'}} /></span>
                        <span>1. แคปหน้าจอนี้</span>
                    </h3>
                    <div className="summary-box-wrapper h3 alight-left semibold">
                        <div className="summary-box-row flex row">
                            <span className="summary-box-label">บริการ : </span>
                            <span className="summary-box-val">{serviceText}</span>
                        </div>
                        {
                            details?.tilesSize?
                            <div className="summary-box-row flex row">
                                <span className="summary-box-label">ขนาดกระเบื้อง : </span>
                                <span className="summary-box-val">{details?.tilesSize}</span>
                            </div>
                            :null
                        }
                        <div className="summary-box-row flex row">
                            <span className="summary-box-label">ขนาดพื้นที่ : </span>
                            <span className="summary-box-val">
                                {details?.areaSize} ตร.ม.
                                {
                                    details?.areaSize < 10?
                                    <>
                                        <br/>
                                        <span className="h6 red-text alight-left">(*พื้นที่ต่ำกว่า 10 ตร.ม. จะคิดค่าบริการขั้นต่ำ 10 ตร.ม. ทันที)</span>
                                    </>
                                    :null
                                }
                            </span>
                        </div>
                        <div className="summary-box-row flex row">
                            <span className="summary-box-label">บริเวณ : </span>
                            <span className="summary-box-val">{areaType?.[details?.areaType]} {roomType?.[details?.room]} {floorType?.[details?.floor]}</span>
                        </div>
                        {
                            selectedTile?
                            <div className="summary-box-row flex row">
                                <span className="summary-box-label">ลายกระเบื้อง : </span>
                                <span className="summary-box-val">{selectedTile?.name}</span>
                            </div>
                            :null
                        }
                        {
                            selectedYaneaw?
                            <div className="summary-box-row flex row">
                                <span className="summary-box-label">สียาแนว : </span>
                                <span className="summary-box-val">{selectedYaneaw?.name}</span>
                            </div>
                            :null
                        }
                    </div>
                </div>
                <div>
                    <h3 id="simple-modal-title">
                        <span className="round-icon-wrapper"><img src="/asset/line_transparent.png" style={{width: '20px', height: '20px'}} /></span>
                        <span>2. Add Line 24 FIX และส่งรูปที่แคปมาให้เราเพื่อความต่อเนื่อง</span>
                    </h3>
                    <a 
                    href="https://line.me/R/ti/p/%40372nmsnv" 
                    target="_blank"
                    style={{width: '100%'}}
                    className="line-button"
                    >
                        <Button 
                        variant="contained" 
                        text="Add Line 24 FIX" 
                        fullWidth
                        backgroundColor="#00b900"
                        startIcon={<img src="/asset/lineicon.png" style={{width: '30px', height: '30px'}} />}
                        style={{borderWidth: 0, marginTop: "10px"}}
                        />
                    </a>
                </div>
                <div className="floating-kay" style={{top: '36px'}}>
                    <img className="kay-container" src="/asset/kay_float.png" />
                </div>
                <div 
                className="close-modal-container red-text h1 bold"
                onClick={handleClose}
                >
                    <CloseIcon/>
                </div>
            </div>
            </Modal>
            {/* <HeaderLogo /> */}

            <div className="flex row mainpadding">
                <Link to={
                location.pathname === "/tiles/notiles/summary"
                ?"/tiles/notiles/services"
                :"/tiles/withtiles/services"
                } className="back-button">
                    <div>{'< กลับ'}</div>
                </Link>
                <div className="bread-crump">
                    <span className="h5 grey-text semibold">
                        รายละเอียด / เลือกบริการ / <span className="green-text">สรุปข้อมูล</span>
                    </span>
                </div>
            </div>
            {/* <div className="cover-title-card box-shadow">
                {
                    location.pathname === "/tiles/notiles/summary"
                    ?<div className="cover-header-container red-bg box-shadow h3">เลือกกระเบื้อง + หาช่าง</div>
                    :<div className="cover-header-container red-bg box-shadow h3">หาช่างอย่างเดียว</div>
                }        
            </div> */}

            <div className="summary-content-wrapper mainpadding" style={{position: 'relative'}}>
                <div className="floating-kay" style={{zIndex: 99}} >
                    <img className="kay-container" src="/asset/kay_float.png" />
                </div>
                <div className="h1 bold">
                    สรุปข้อมูลบริการ
                </div>
                <div className="summary-box-wrapper h3 alight-left semibold">
                    <div className="summary-box-row flex row">
                        <span className="summary-box-label">บริการ : </span>
                        <span className="summary-box-val">{serviceText}</span>
                    </div>
                    {
                        details?.tilesSize?
                        <div className="summary-box-row flex row">
                            <span className="summary-box-label">ขนาดกระเบื้อง : </span>
                            <span className="summary-box-val">{details?.tilesSize}</span>
                        </div>
                        :null
                    }
                    <div className="summary-box-row flex row">
                        <span className="summary-box-label">ขนาดพื้นที่ : </span>
                        <span className="summary-box-val">
                            {details?.areaSize} ตร.ม.
                            {
                                details?.areaSize < 10?
                                <>
                                    <br/>
                                    <span className="h6 red-text alight-left">(*พื้นที่ต่ำกว่า 10 ตร.ม. จะคิดค่าบริการขั้นต่ำ 10 ตร.ม. ทันที)</span>
                                </>
                                :null
                            }
                        </span>
                    </div>
                    <div className="summary-box-row flex row">
                        <span className="summary-box-label">บริเวณ : </span>
                        <span className="summary-box-val">{areaType?.[details?.areaType]} {roomType?.[details?.room]} {floorType?.[details?.floor]}</span>
                    </div>
                    {
                        selectedTile?
                        <div className="summary-box-row flex row">
                            <span className="summary-box-label">ลายกระเบื้อง : </span>
                            <span className="summary-box-val">{selectedTile?.name}</span>
                        </div>
                        :null
                    }
                    {
                        selectedYaneaw?
                        <div className="summary-box-row flex row">
                            <span className="summary-box-label">สียาแนว : </span>
                            <span className="summary-box-val">{selectedYaneaw?.name}</span>
                        </div>
                        :null
                    }
                </div>
                <div>
                    <div className="h1 bold">รายละเอียดการทำงาน</div>
                    <div className="h6"><br/></div>
                    <Accordion>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        >
                        <span>ขั้นตอนการทำงาน</span>
                        </AccordionSummary>
                        <AccordionDetails>
                        <span className="alight-left">
                            1. ตรวจเช็คพื้นที่การทำงาน<br/>
                            - ช่างจะจัดเตรียมหน้างานและขนวัสดุ อุปกรณ์เข้าพื้นที่หน้างาน<br/>
                            - ช่างตรวจวัดพื้นที่หน้างาน<br/>
                            2. ดำเนินการปูกระเบื้อง<br/>
                            - ช่างรื้อถอนกระเบื้อง หรือ พื้นเก่าออก (กรณีมีพื้นเก่า)<br/>
                            - ปรับระดับพื้นให้เท่ากันโดยใช้ปูนทราย (กำหนดความหนาไม่เกิน 5 มม.)<br/>
                            - ปูกระเบื้องตามแบบ หรือ แนวเดิมของพื้นที่ลูกค้า (กรณีไม่มีแบบ ช่างจะปูตามระดับหรือแนว)<br/>
                            - ลงยาแนวร่องกระเบื้อง และเก็บความเรียบร้อย<br/>
                            3. ตรวจสอบความเรียบร้อยของงาน<br/>
                            - ตรวจสอบความเรียบร้อยของงานและทำความสะอาดพื้นที่หน้างาน<br/>
                            4. เก็บอุปกรณ์ออกจากพื้นที่
                        </span>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        >
                        <span>ขอบเขตการทำงาน</span>
                        </AccordionSummary>
                        <AccordionDetails>
                        <span className="alight-left">
                            1. บริการเฉพาะการรื้อและปูกระเบื้องขนาด 30 x 30 cm - 60 x 60 cm เท่านั้น<br/>
                            2. บริการรวมการปรับระดับพื้นด้วยปูทรายหนาไม่เกิน 5 มม. และปูกระเบื้องด้วยปูนกาว<br/>
                            3. บริการรวมค่าแรงและวัสดุผสาน<br/>
                            - ปูนทราย (ปรับระดับ)<br/>
                            - ปูนกาว (ติดกระเบื้อง)<br/>
                            - กาวยาแนว<br/>
                            4. ระยะเวลาดำเนินการขึ้นอยู่กับขนาดพื้นที่โดยลูกค้าต้องอยู่เฝ้าหรือมีผู้แทนเฝ้าระหว่างการดำเนินการ<br/>
                        </span>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        >
                        <span>เงื่อนไขการดำเนินการ</span>
                        </AccordionSummary>
                        <AccordionDetails>
                        <span className="alight-left">
                            1. กรณีลูกค้าไม่มีแบบ ช่างจะปูตามระดับหรือแนวของพื้นที่ลูกค้า<br/>
                            2. บริษัทฯขอสงวนสิทธิ์ในการให้บริการ กรณีหน้างานต้องปรับระดับสูงเกินกว่า 5 มม.และจะต้องทำราคาใหม่<br/>
                            3. กรณีไม่ใช่ห้องโล่งว่างจะต้องมีค่าดำเนินการขนย้ายของ<br/>
                            4. หากบริษัทฯ พิจารณาแล้วเห็นว่าการดำเนินการมีความอันตรายหรือไม่ได้มาตรฐาน ขอสงวนสิทธิ์ในการให้บริการ และขอสงวนสิทธิ์ในการคืนค่าวัสดุทั้งหมด และหักค่าดำเนินการเป็นจำนวนไม่น้อยกว่า 20%<br/>
                            5. กรณีหน้างานมีขนาดพื้นที่ หรือ ปริมาณงาน ไม่ตรงกับข้อมูลที่ลูกค้าแจ้งตามรายละเอียดใบงานและใบเสนอราคา จะคิดค่าใช้จ่ายเพิ่มเติมตามขนาดพื้นที่หน้างานจริง และกรณีสั่งซื้อวัสดุส่วนเพิ่มไม่ทันภายในวันดำเนินการ บริษัทฯ จะคิดค่าใช้จ่ายเพิ่มเติมตาม ราคาเริ่มต้นมาตรฐานใหม่
                        </span>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        >
                        <span>เงื่อนไขการรับประกัน</span>
                        </AccordionSummary>
                        <AccordionDetails>
                        <span className="alight-left">
                            1. ระยะเวลารับประกัน 60 วัน<br/>
                            2. รับประกันงานผลงานหลังการให้บริการ ต้องไม่มีกระเบื้องร่อน กระเบื้องหลุดจากการติดตั้ง<br/>
                            3. กรณีต้องการแจ้งแก้ไขงานรับประกัน จะต้องแจ้งภายใน 7 วัน <br/>
                            4. เงื่อนไขการรับประกันอื่นๆ เป็นไปตามกำหนดที่ระบุไว้บน เว็บไซต์ www.24fix.co เท่านั้น<br/>
                        </span>
                        </AccordionDetails>
                    </Accordion>
                </div>
                <div style={footerHeight}></div>
            </div>
            <div id="fix-footer" className="summary-footer-wrapper">
                <div className="summary-footer-container">
                    <div className="summary-footer-row alight-left h4 semibold flex row">
                        <span className="summary-footer-label">รวม ค่าแรงปูกระเบื้อง (รวมวัสดุ)</span>
                        <span className="summary-footer-val">฿ {summaryPrice?.total.toLocaleString('en', localeoptions)}</span>
                    </div>
                    <div className="summary-footer-row alight-left red-text h4 semibold flex row">
                        <span className="summary-footer-label">พี่เข้ออกส่วนลดให้</span>
                        <span className="summary-footer-val">-฿ {summaryPrice?.discount.toLocaleString('en', localeoptions)}</span>
                    </div>
                    <div className="summary-footer-row alight-left h4 semibold flex row">
                        <span className="summary-footer-label">VAT 7%</span>
                        <span className="summary-footer-val">฿ {summaryPrice?.vat.toLocaleString('en', localeoptions)}</span>
                    </div>
                    <div className="summary-footer-row alight-left h3 bold flex row">
                        <span className="summary-footer-label">ราคารวมทั้งหมด</span>
                        <span className="summary-footer-val">฿ {summaryPrice?.totalvat.toLocaleString('en', localeoptions)}</span>
                    </div>
                    <div>
                        <Button 
                        fullWidth
                        variant="contained" 
                        text="ขอคำปรึกษาเพิ่มเติม" 
                        backgroundColor="#00b900"
                        className="consult-button"
                        mediumText={true}
                        style={{borderWidth: 0, marginTop: "10px"}}
                        startIcon={<img src="/asset/lineicon.png" style={{width: '30px', height: '30px'}} />}
                        onPress={handleOpen}
                        />
                    </div>
                </div>
                <a 
                href={bookingLink} 
                target="_blank"
                style={{width: '100%'}}
                >
                    <Button 
                    fullWidth 
                    text={'จองบริการ >'} 
                    bigText={true}
                    />
                </a>
            </div>
        </div>
    );
}

export default CustomServicePage;
